import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getDecryptedUserFromCookie } from "../utils/getCookie";
const formatIndianCurrency = (value) => {
    const num = value.replace(/,/g, ''); // Remove commas
    if (!/^\d+$/.test(num)) return value; // Only format if valid number
    return Number(num).toLocaleString('en-IN');
};

const numberToWords = (num) => {
    const a = [
        '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
        'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen',
        'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'
    ];
    const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    const inWords = (n) => {
        if ((n = n.toString()).length > 9) return 'Overflow';
        const nNum = ('000000000' + n).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
        if (!nNum) return;
        let str = '';
        str += nNum[1] !== '00' ? (a[Number(nNum[1])] || b[nNum[1][0]] + ' ' + a[nNum[1][1]]) + ' Crore ' : '';
        str += nNum[2] !== '00' ? (a[Number(nNum[2])] || b[nNum[2][0]] + ' ' + a[nNum[2][1]]) + ' Lakh ' : '';
        str += nNum[3] !== '00' ? (a[Number(nNum[3])] || b[nNum[3][0]] + ' ' + a[nNum[3][1]]) + ' Thousand ' : '';
        str += nNum[4] !== '0' ? a[Number(nNum[4])] + ' Hundred ' : '';
        str += nNum[5] !== '00' ? ((str !== '') ? 'and ' : '') + (a[Number(nNum[5])] || b[nNum[5][0]] + ' ' + a[nNum[5][1]]) + ' ' : '';
        return str.trim() + ' Rupees Only';
    };

    return inWords(num.replace(/,/g, ''));
};

const EnquiryFormModal = ({ showEnquiryModal, closeModal }) => {
    const [orderId, setOrderId] = useState("");
    const [receiptId, setReceiptId] = useState("");
    const [currency, setCurrency] = useState("INR");
    const [orderStatus, setOrderStatus] = useState("Pending");
    const [amountBeforeDiscount, setAmountBeforeDiscount] = useState("");
    const [amountAfterDiscount, setAmountAfterDiscount] = useState("");
    const [discountPrice, setDiscountPrice] = useState("");
    const [couponCode, setCouponCode] = useState("");
    const [productSearch, setProductSearch] = useState("");
    const [products, setProducts] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const url = process.env.REACT_APP_LINK

    // Billing and Shipping Address States
    const [billing, setBilling] = useState({
        location_user: "",
        city: "",
        new_address: "",
        pincode: "",
    });
    const [shipping, setShipping] = useState({
        location_user: "",
        city: "",
        new_address: "",
        pincode: "",
    });

    // Utility functions
    const updateBilling = (key, value) => {
        setBilling(prev => ({ ...prev, [key]: value }));
    };
    const updateShipping = (key, value) => {
        setShipping(prev => ({ ...prev, [key]: value }));
    };
    const removeProduct = (productId) => {
        setSelectedProducts(prev => prev.filter(p => p.product_id !== productId));
    };


    const [allProducts, setAllProducts] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');

    useEffect(() => {
        fetch(`${url}/grouped-product/search-all-products`)
            .then(res => res.json())
            .then(setProducts)
            .catch(console.error);
    }, []);

    const handleProductSelect = (product) => {
        setSelectedProducts(prev => {
            const isAlreadySelected = prev.some(p => p.product_id === product.product_id);
            if (!isAlreadySelected) {
                return [...prev, product];
            }
            return prev;
        });
    };

    // const handleProductSelect = (product) => {
    //     setForm((prev) => ({
    //         ...prev,
    //         cart_products: [...prev.cart_products, product]
    //     }));
    // };





    const handleSubmit = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_LINK}/orders`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                // body: JSON.stringify(form),
            });
            const result = await response.json();
            console.log(result);
        } catch (err) {
            console.error(err);
        }
    };

    // const filteredProducts = allProducts.filter(p =>
    //     p.product_name.toLowerCase().includes(searchQuery.toLowerCase())
    // );

    if (!showEnquiryModal) return null;

    return (
        <div className="ls-enquiry-modal">
            <div className="ls-enquiry-modal-content">
                <div className="quotation-header">
                    <h2><i className="fa-solid fa-envelope"></i> New Enquiry</h2>
                    <button className="quotation-close" onClick={closeModal}>
                        <i className="fa-solid fa-xmark"></i>
                    </button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="ls-form-row">
                        <div className="ls-form-group">
                            <label>Order ID</label>
                            <input type="text" value={orderId} onChange={(e) => setOrderId(e.target.value)} placeholder="Enter Order ID" />
                        </div>
                        <div className="ls-form-group">
                            <label>Receipt ID</label>
                            <input type="text" value={receiptId} onChange={(e) => setReceiptId(e.target.value)} placeholder="Enter Receipt ID" />
                        </div>
                    </div>

                    <div className="ls-form-row">
                        <div className="ls-form-group">
                            <label>Currency</label>
                            <input type="text" value={currency} onChange={(e) => setCurrency(e.target.value)} placeholder="INR / USD" />
                        </div>
                        <div className="ls-form-group">
                            <label>Order Status</label>
                            <select value={orderStatus} onChange={(e) => setOrderStatus(e.target.value)}>
                                <option value="">Select</option>
                                <option value="Pending">Pending</option>
                                <option value="Processing">Processing</option>
                                <option value="Shipped">Shipped</option>
                                <option value="Delivered">Delivered</option>
                                <option value="Cancelled">Cancelled</option>
                            </select>
                        </div>
                    </div>
                    <div className="ls-form-row">
                        <div className="ls-form-group">
                            <label>Amount Before Discount</label>
                            <input type="text" value={amountBeforeDiscount} onChange={(e) => setAmountBeforeDiscount(e.target.value)} placeholder="e.g. 675" />
                        </div>
                        <div className="ls-form-group">
                            <label>Amount After Discount</label>
                            <input type="text" value={amountAfterDiscount} onChange={(e) => setAmountAfterDiscount(e.target.value)} placeholder="e.g. 567" />
                        </div>
                    </div>

                    <div className="ls-form-row">
                        <div className="ls-form-group">
                            <label>Discount Price</label>
                            <input type="text" value={discountPrice} onChange={(e) => setDiscountPrice(e.target.value)} placeholder="e.g. 0.00" />
                        </div>
                        <div className="ls-form-group">
                            <label>Coupon Code</label>
                            <input type="text" value={couponCode} onChange={(e) => setCouponCode(e.target.value)} placeholder="Optional" />
                        </div>
                    </div>

                    <div className="ls-form-group">
                        <label>Search & Select Product</label>
                        <input type="text" placeholder="Search products..." value={productSearch} onChange={(e) => setProductSearch(e.target.value)} />
                        {productSearch.trim().length > 0 && (
                            <div className="product-search-results">
                                {products
                                    .filter(p => p.title.toLowerCase().includes(productSearch.toLowerCase()))
                                    .map((product, i) => (
                                        <div key={i} className="product-select-card" onClick={() => handleProductSelect(product)}>
                                            <img src={`${url}${product.image}`} alt="Product" />
                                            <div className="product-info">
                                                <strong>{product.title}</strong>
                                                <p>₹{product.product_saleprice} <span className="sku">(SKU: {product.product_sku})</span></p>
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        )}

                    </div>

                    {/* Selected products display */}
                    {selectedProducts.length > 0 && (
                        <div className="selected-product-list">
                            {selectedProducts.map((prod, idx) => (
                                <div key={idx} className="selected-product-chip">
                                    {prod.title} ({prod.variation_attributes?.Color}/{prod.variation_attributes?.Size})
                                    <i className="fa fa-times" onClick={() => removeProduct(prod.product_id)} />
                                </div>
                            ))}
                        </div>
                    )}
                    <h4 style={{ marginTop: "20px" }}>Billing Address</h4>
                    <div className="ls-form-row">
                        <div className="ls-form-group">
                            <label>City</label>
                            <input type="text" value={billing.city} onChange={(e) => updateBilling('city', e.target.value)} />
                        </div>
                        <div className="ls-form-group">
                            <label>Address</label>
                            <input type="text" value={billing.new_address} onChange={(e) => updateBilling('new_address', e.target.value)} />
                        </div>
                    </div>

                    <h4 style={{ marginTop: "20px" }}>Shipping Address</h4>
                    <div className="ls-form-row">
                        <div className="ls-form-group">
                            <label>City</label>
                            <input type="text" value={shipping.city} onChange={(e) => updateShipping('city', e.target.value)} />
                        </div>
                        <div className="ls-form-group">
                            <label>Address</label>
                            <input type="text" value={shipping.new_address} onChange={(e) => updateShipping('new_address', e.target.value)} />
                        </div>
                    </div>



                    <div className="ls-modal-action">
                        <button className="ls-modal-cancel" onClick={closeModal}>Cancel</button>
                        <button className="ls-apply-btn">Submit</button>
                    </div>
                </form>
            </div>
            <ToastContainer />
        </div>
    );
};

export default EnquiryFormModal;
